import { Component, ElementRef, inject, OnDestroy } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { RouterLink } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    imports: [
        RouterLink,
        MenuComponent,
    ],
})
export class SidebarComponent implements OnDestroy {

    public layoutService = inject(LayoutService);
    public el = inject(ElementRef);


    resetOverlay(): void {
        if (this.layoutService.state.overlayMenuActive) {
            this.layoutService.state.overlayMenuActive = false;
        }
    }

    ngOnDestroy(): void {
        this.resetOverlay();
    }

}
